var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var ActiveRelayPinger =
/*#__PURE__*/
function () {
  "use strict";

  // TODO: 'httpSend' should be on a network layer
  function ActiveRelayPinger(filteredRelays, httpSend, gasPrice) {
    _classCallCheck(this, ActiveRelayPinger);

    this.remainingRelays = filteredRelays.slice();
    this.httpSend = httpSend;
    this.pingedRelays = 0;
    this.relaysCount = filteredRelays.length;
    this.gasPrice = gasPrice;
  }
  /**
   * Ping those relays that were not returned yet. Remove the retuned relay (first to respond) from {@link remainingRelays}
   * @returns the first relay to respond to a ping message. Note: will never return the same relay twice.
   */


  _createClass(ActiveRelayPinger, [{
    key: "nextRelay",
    value: function () {
      var _nextRelay = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var firstRelayToRespond, bulkSize;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.remainingRelays.length === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", null);

              case 2:
                if (!(!firstRelayToRespond && this.remainingRelays.length)) {
                  _context.next = 16;
                  break;
                }

                bulkSize = Math.min(3, this.remainingRelays.length);
                _context.prev = 4;
                _context.next = 7;
                return this.raceToSuccess(this.remainingRelays.slice(0, bulkSize).map(function (relay) {
                  return _this.getRelayAddressPing(relay.relayUrl, _this.gasPrice);
                }));

              case 7:
                firstRelayToRespond = _context.sent;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](4);
                console.log("One batch of relays failed, last error: ", _context.t0); //none of the first `bulkSize` items matched. remove them, to continue with the next bulk.

                this.remainingRelays = this.remainingRelays.slice(bulkSize);

              case 14:
                _context.next = 2;
                break;

              case 16:
                this.remainingRelays = this.remainingRelays.filter(function (a) {
                  return a.relayUrl !== firstRelayToRespond.relayUrl;
                });
                this.pingedRelays++;
                return _context.abrupt("return", firstRelayToRespond);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function nextRelay() {
        return _nextRelay.apply(this, arguments);
      }

      return nextRelay;
    }()
    /**
     * @returns JSON response from the relay server, but adds the requested URL to it:
     * { relayUrl: url,
     *   RelayServerAddress: address,
     *   Ready: bool,   //should ignore relays with "false"
     *   MinGasPrice:   //minimum gas requirement by this relay.
     * }
     */

  }, {
    key: "getRelayAddressPing",
    value: function () {
      var _getRelayAddressPing = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(relayUrl, gasPrice) {
        var self;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var callback = function callback(error, body) {
                    if (error) {
                      reject(error);
                      return;
                    }

                    if (!body || !body.Ready || body.MinGasPrice > gasPrice) {
                      reject("Relay not ready or proposed gas price too low " + JSON.stringify(body));
                      return;
                    }

                    try {
                      body.relayUrl = relayUrl;
                      resolve(body);
                    } catch (err) {
                      reject(err);
                    }
                  };

                  self.httpSend.send(relayUrl + "/getaddr", {}, callback);
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRelayAddressPing(_x, _x2) {
        return _getRelayAddressPing.apply(this, arguments);
      }

      return getRelayAddressPing;
    }()
    /**
     * From https://stackoverflow.com/a/37235207 (modified to catch exceptions)
     * Resolves once any promise resolves, ignores the rest, ignores rejections
     */

  }, {
    key: "raceToSuccess",
    value: function () {
      var _raceToSuccess = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(promises) {
        var numRejected;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                numRejected = 0;
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  return promises.forEach(function (promise) {
                    return promise.then(function (res) {
                      resolve(res);
                    }).catch(function (err) {
                      if (++numRejected === promises.length) {
                        reject("No response matched filter from any server: " + err);
                      }
                    });
                  });
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function raceToSuccess(_x3) {
        return _raceToSuccess.apply(this, arguments);
      }

      return raceToSuccess;
    }()
  }]);

  return ActiveRelayPinger;
}();

var ServerHelper =
/*#__PURE__*/
function () {
  "use strict";

  /**
   *
   * @param {*} minStake
   * @param {*} minDelay
   * @param {*} httpSend
   */
  function ServerHelper(minStake, minDelay, httpSend) {
    _classCallCheck(this, ServerHelper);

    this.minStake = minStake;
    this.minDelay = minDelay;
    this.httpSend = httpSend;
    this.filteredRelays = [];
    this.isInitialized = false;
    this.ActiveRelayPinger = ActiveRelayPinger;
  }
  /**
   *
   * @param {*} relayHubInstance
   */


  _createClass(ServerHelper, [{
    key: "setHub",
    value: function setHub(relayHubInstance) {
      if (this.relayHubInstance !== relayHubInstance) {
        this.filteredRelays = [];
      }

      this.relayHubInstance = relayHubInstance;
      this.relayHubAddress = this.relayHubInstance._address;
    }
  }, {
    key: "newActiveRelayPinger",
    value: function () {
      var _newActiveRelayPinger = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(fromBlock, gasPrice) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(typeof this.relayHubInstance === 'undefined')) {
                  _context4.next = 2;
                  break;
                }

                throw new Error("Must call to setHub first!");

              case 2:
                if (!(this.filteredRelays.length == 0 || this.fromBlock !== fromBlock)) {
                  _context4.next = 6;
                  break;
                }

                this.fromBlock = fromBlock;
                _context4.next = 6;
                return this.fetchRelaysAdded();

              case 6:
                return _context4.abrupt("return", this.createActiveRelayPinger(this.filteredRelays, this.httpSend, gasPrice));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function newActiveRelayPinger(_x4, _x5) {
        return _newActiveRelayPinger.apply(this, arguments);
      }

      return newActiveRelayPinger;
    }()
  }, {
    key: "createActiveRelayPinger",
    value: function createActiveRelayPinger(filteredRelays, httpSend, gasPrice) {
      return new ActiveRelayPinger(filteredRelays, httpSend, gasPrice);
    }
    /**
     * Iterates through all RelayAdded and RelayRemoved logs emitted by given hub
     * initializes an array {@link filteredRelays} of relays curently registered on given RelayHub contract
     */

  }, {
    key: "fetchRelaysAdded",
    value: function () {
      var _fetchRelaysAdded = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var activeRelays, fromBlock, addedAndRemovedEvents, index, event, args, filteredRelays, origRelays, size;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                activeRelays = {};
                fromBlock = this.fromBlock || 2;
                _context5.next = 4;
                return this.relayHubInstance.getPastEvents("allEvents", {
                  fromBlock: fromBlock // topics: [["RelayAdded", "RelayRemoved"]]

                });

              case 4:
                addedAndRemovedEvents = _context5.sent;

                for (index in addedAndRemovedEvents) {
                  event = addedAndRemovedEvents[index];

                  if (event.event === "RelayAdded") {
                    args = event.returnValues;
                    activeRelays[args.relay] = {
                      address: args.relay,
                      relayUrl: args.url,
                      transactionFee: args.transactionFee,
                      stake: args.stake,
                      unstakeDelay: args.unstakeDelay
                    };
                  } else if (event.event === "RelayRemoved") {
                    delete activeRelays[event.returnValues.relay];
                  }
                }

                filteredRelays = Object.values(activeRelays);
                origRelays = filteredRelays;

                if (this.minStake) {
                  filteredRelays = filteredRelays.filter(function (a) {
                    return a.stake >= _this2.minStake;
                  });
                }

                if (this.minDelay) {
                  filteredRelays = filteredRelays.filter(function (a) {
                    return a.unstakeDelay >= _this2.minDelay;
                  });
                }

                size = filteredRelays.length;

                if (!(size == 0)) {
                  _context5.next = 13;
                  break;
                }

                throw new Error("no valid relays. orig relays=" + JSON.stringify(origRelays));

              case 13:
                filteredRelays = filteredRelays.sort(function (a, b) {
                  return a.txFee - b.txFee;
                }).slice(0, size);
                this.filteredRelays = filteredRelays;
                this.isInitialized = true;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchRelaysAdded() {
        return _fetchRelaysAdded.apply(this, arguments);
      }

      return fetchRelaysAdded;
    }()
  }]);

  return ServerHelper;
}();

module.exports = ServerHelper;